import {usePlaybackToggle} from '../../hooks/usePlaybackToggle';
import PlayIcon from './playIcon.svg';
import PauseIcon from './pauseIcon.svg';
import {ControlButton} from '../controlButton';
import {useIsPlaying, useIsSeeking} from '../../hooks/usePlayerState';
import {FC, useEffect, useState} from 'react';

export const PlayPauseButton: FC = () => {
  const onClick = usePlaybackToggle();
  const isPlaying = useIsPlaying();
  const isSeeking = useIsSeeking();

  const [displayAsPlaying, setDisplayAsPlaying] = useState(isPlaying);
  const label = displayAsPlaying ? 'Pause' : 'Play';

  // Update the displayed value when these context values change.
  // If `isSeeking` changed, we want to persist the last state.
  // The UI should only change when `isPlaying` changed, but `isSeeking` did not.
  useEffect(() => {
    if (isSeeking) return;

    setDisplayAsPlaying(isPlaying);
  }, [isSeeking, isPlaying]);

  return (
    <ControlButton
      ariaLabel={label}
      ariaPressed={!displayAsPlaying}
      tooltipLabel={label}
      onClick={onClick}
    >
      {displayAsPlaying ? <PauseIcon /> : <PlayIcon />}
    </ControlButton>
  );
};
